import React from 'react';
import { useLocation } from 'react-router-dom';
import FloatingContactFAB from './FloatingContactFAB';
import BackToTopFAB from './BackToTopFAB';
import FloatingMenuFAB from './FloatingMenuFAB';
import FloatingMessagesFAB from './FloatingMessagesFAB';

/**
 * FloatingActionStack (iter59, extended iter70, iter95)
 *
 * Single mount-point for the floating action buttons. Top → bottom order:
 *   1. Messages   (FloatingMessagesFAB, bottom-[180px]) — iter95
 *   2. Profile    (FloatingMenuFAB,     bottom-[124px])
 *   3. Contact Us (FloatingContactFAB,  bottom-[68px])
 *   4. Back to Top (BackToTopFAB,       bottom-3)
 *
 * Hidden on focus / chrome-heavy pages where the FABs would compete with
 * native UI: chat threads, ad-posting, admin panel, complete-profile, login.
 */

const HIDE_ON_PREFIXES = ['/chat', '/post-ad', '/admin', '/complete-profile', '/login'];

const FloatingActionStack = () => {
  const { pathname } = useLocation();
  const hide = HIDE_ON_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'));
  if (hide) return null;
  return (
    <>
      <FloatingMessagesFAB />
      <FloatingMenuFAB />
      <FloatingContactFAB />
      <BackToTopFAB />
    </>
  );
};

export default FloatingActionStack;
